﻿export const carouselState = function () {
	return {
		slideIndex: 0,
		carouselData: null,
		wasCycledManually: true,
		container: null,
		currentImagePath: "",
		showNavigation: false,
		slideInterval: null,
		/**
		 * INIT METHOD.
		 * Sets the initialPageLength, defaults to 10.
		 * Sets the column filter options.
		 */
		setupComponent: function ({ index, carouselData, showNavigation }) {
			this.container = this.$refs.container;
			this.carouselData = carouselData;
			this.showNavigation = showNavigation;
			this.slideStart();
		},

		get carouselItems() {
			return this.carouselData;
		},

		getCarouselItemMarkup: function () {
			if (this.carouselItems === null) {
				return "";
			}
			else if (this.carouselItems[this.slideIndex] === null) {
				return "";
			} else {
				return this.carouselItems[this.slideIndex].Contents;
			}
		},

		// Next/previous controls
		previous: function () {
			this.slideStop();
			this.slideIndex -= 1
			if (this.slideIndex < 0) {
				this.slideIndex = this.carouselData.length - 1;
			}
			this.scrollTo(this.slideIndex);
			this.slideStart();
		},

		next: function () {
			this.slideStop();
			this.slideIndex += 1
			if (this.slideIndex > this.carouselData.length - 1) {
				this.slideIndex = 0;
			}
			this.scrollTo(this.slideIndex);
			this.slideStart();
		},

		scrollTo: function (index) {
			this.slideIndex = index;
			//document.getElementsByClassName('ftui__carousel--slide')[this.slideIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
			let f = document.getElementsByClassName('ftui__carousel--navigation-button');
			for (let i = 0; i < f.length; i++) {
				if (i === index) {
					f[i].style.backgroundColor = '#2278cd';
				}
				else {
					f[i].style.removeProperty('background-color');
				}
			}
			this.updateStyle();
		},

		updateStyle: function () {
			if (this.carouselItems === null) {
				return "";
			}
			else if (this.carouselItems[this.slideIndex] === null) {
				return "";
			} else {
				return "background-image: url(" + this.carouselItems[this.slideIndex].ImagePath + "); background-size: cover; background-repeat: no-repeat; height: 70vh; transition: 1s";
			}

		},

		slideStart: function () {
			if (this.showNavigation) {
				this.slideInterval = setInterval(
					(function (self) {
						return function () { self.next(); }
					})(this), 3000);
			}
		},

		slideStop: function () {
			clearInterval(this.slideInterval);
		},


	};
};
